import { render, staticRenderFns } from "./AboutCommitteesIndex.vue?vue&type=template&id=2f14d9bb&"
import script from "./AboutCommitteesIndex.vue?vue&type=script&lang=js&"
export * from "./AboutCommitteesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports